import React from 'react';
import ReactDOM from 'react-dom';
import 'bulma/css/bulma.min.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Amplify from 'aws-amplify';
import config from './config.json'

Amplify.configure({
    Auth:{
        mandatorySignIn:true,
        region:config.congnito.REGION,
        userPoolId:config.congnito.USER_POOL_ID,
        identityPoolId:config.congnito.IDENTITY_POOL_ID,
        userPoolWebClientId:config.congnito.APP_CLIENT_ID,
        authenticationFlowType:config.congnito.FLOW_TYPE
    }
})

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
